<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  // import '../static/service.js' // 停用

  export default {
    name: 'App'
  }
</script>

<style>
  ::-webkit-scrollbar {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue